import React from 'react'
import './style.css';
export default function ProjectOverviewSection({project}) {
    

    return (
        <div className='project-details-main-container'>
            <div className='project-details-title-container'>
                <p className='prd-title'>{project.title}</p>
                <div className='stat-info-list'>
                        <InfoLabel label="TECH" value={project.tech} />
                        <dvi className="stat-vertical-line" />
                        <InfoLabel label="ROLE" value={project.role} />
                        <dvi className="stat-vertical-line" />
                        <InfoLabel label="YEAR" value={project.year} />
                </div>
                {project.type === "WEB" ||project.type === "APP & WEB"? 
                <img src={require("../../../assets/images/website.png")} className='project-details-type-chip-image-website' />:null}
                {project.type === "APP" ||project.type === "APP & WEB"?
                <img src={require("../../../assets/images/app2.png")} className='project-details-type-chip-image-app' />:null}
            </div>
            <p className='overview-title'>Overview</p>
            <p className='overview-content'>{project.about}</p>
        </div>
    )
}





function InfoLabel(props) {
    return (
        <div className='info-container'>
            <p className='info-label'>{props.label}</p>
            <p className='info-value'>{props.value}</p>
        </div>
    )
}
